import React, { useState, useEffect } from 'react';
import BackNavbar from '../../../ReusableBlocks/Navbar';
import Footer from '../../../ReusableBlocks/FooterBlock';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { normalizeMediaUrl } from '../../../Utils/mediaUrls';

const PlaybookView = () => {

  
  
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  
  // State to hold playbook data
  const [playbook, setPlaybook] = useState(null);

  // Retrieve playbook data from sessionStorage
  useEffect(() => {
    const playbookData = localStorage.getItem('playbookData');
    if (playbookData) {
      setPlaybook(JSON.parse(playbookData));
      console.log(JSON.parse(playbookData))
    }
  }, []);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        enqueueSnackbar('Password copied to clipboard!', { variant: 'success' });
      })
      .catch(() => {
        enqueueSnackbar('Failed to copy Password.', { variant: 'error' });
      });
  };

  const handleBack = () => {
    window.location.href = document.referrer; // Go back to the previous page
  };

  return (
    <>
      <BackNavbar />

      <section className='playbook-view-popup'>
        <div className="container">
          <div className='modal-div-learning'>
            <div className="row">
              <div className="col-sm-8 mb-3 mb-sm-0">
                <div className="file-container">
                  <iframe
                    src={normalizeMediaUrl(playbook?.viewUrl, 'preview')}
                    frameBorder="0"
                    width="100%"
                    height="100%"
                    allowFullScreen
                    title="File Preview"
                  ></iframe>
                </div>
              </div>
              <div className="col-sm-4 mb-3 mb-sm-0">
                <div className="file-controls-dive">
                  <h1 className='file-tite-des'>{playbook?.title}</h1>
                  <div className="line"></div>

                  <p className='file-p-des'>Password:
                    <span
                      onClick={() => copyToClipboard('Playbook@123')}
                      style={{ cursor: 'pointer' }}
                      className='new-passowrd'
                    >
                      Copy Password
                    </span>
                  </p>

                  <button className='card-cat-cancel' onClick={handleBack}>
                    Back to Narrative
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      
    </>
  );
}

export default PlaybookView;
